export default "__VITE_ASSET__B1LlMl$w__"